<template>
  <v-navigation-drawer
    :value="value"
    right
    temporary
    fixed
    width="480"
    @input="$emit('input', $event)"
  >
    <div v-if="detail" class="pa-4">
      <h3 class="mb-2">User activity</h3>
      <h4>By review</h4>
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Review</th>
            <th>Screen</th>
            <th>FT</th>
            <th>Comments</th>
            <th>Extractions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in detail.reviewBreakdown" :key="r.reviewId">
            <td>{{ r.title }}</td>
            <td>{{ r.screeningVotes }}</td>
            <td>{{ r.fullTextVotes }}</td>
            <td>{{ r.comments }}</td>
            <td>{{ r.extractionReports }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <h4 class="mt-4">Signal activity</h4>
      <div
        v-for="t in detail.signalTimelines"
        :key="t.signal"
        class="text-caption"
      >
        {{ t.signal }} —
        {{
          t.weeklyActivity
            .map((w) => w.count)
            .reduce((a, b) => a + b, 0)
        }}
        this window
      </div>
    </div>
    <div v-else class="pa-4">Loading…</div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'UserActivityDetailPanel',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    researcherId: {
      type: String,
      default: null,
    },
  },
  emits: ['input'],
  data: () => ({
    detail: null,
  }),
  watch: {
    async researcherId(id) {
      this.detail = null;
      if (id) {
        this.detail = await this.$store.dispatch(
          'adminActivity/fetchUserDetail',
          id
        );
      }
    },
  },
};
</script>
